import React from 'react'
import { FlexColumn, Text, Anchor, Icon } from 'elements'

export default function ReportStatusUnknown() {
  return (
    <FlexColumn p="xxlarge" alignItems="center">
      <Icon name="exclamation-circle" color="neutral.2" size="xxlarge" mb="medium" />
      <Text fontSize="xlarge" color="neutral.0" mb="xxxlarge" textAlign="center">
        There was an error processing your request. Our support team has been notified and is
        investigating the issue.
      </Text>
      <Text color="neutral.0" textAlign="center" mb="xxxlarge">
        Please feel free to review our support documentation or create a ticket{' '}
        <Anchor href="https://scrutinize.freshdesk.com/support/home" target="_blank">
          here.
        </Anchor>
      </Text>
    </FlexColumn>
  )
}
